export default __webpack_public_path__ + "static/DSC_0059-d65d5dec527648ebfd957f15830a82c8.jpg";